import styled from "styled-components";
import {
  borderRadius,
  borderStyle,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import type { KeyBadgeKind } from "./KeyBadge.types";

const hairlineBorder = `${borderWidth.hairline} ${borderStyle.solid}`;

const KEY_BADGE_TONES: Record<
  KeyBadgeKind,
  { color: string; bg: string; border: string }
> = {
  PK: {
    color: rawColors.accent.pkColor,
    bg: rawColors.accent.pkBg,
    border: rawColors.accent.pkBorder,
  },
  FK: {
    color: rawColors.accent.fkColor,
    bg: rawColors.accent.fkBg,
    border: rawColors.accent.fkBorder,
  },
  DIM: {
    color: rawColors.grey[700],
    bg: rawColors.grey[300],
    border: rawColors.grey[400],
  },
  MS: {
    color: rawColors.accent.green,
    bg: rawColors.accent.greenLight,
    border: rawColors.accent.green,
  },
};

/**
 * Visual GAP (carried over from the original molecule-local implementation):
 * font-size 8px / line-height 12px / Plus Jakarta Sans literal have no
 * matching typography mixin. Flagged in KeyBadge.styleMap.md. Preserved here
 * to keep the refactor pixel-identical.
 */
export const Badge = styled.span<{ $kind: KeyBadgeKind }>`
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 8px;
  font-weight: 400;
  line-height: 12px;
  color: ${({ $kind }) => KEY_BADGE_TONES[$kind].color};
  background: ${({ $kind }) => KEY_BADGE_TONES[$kind].bg};
  border: ${hairlineBorder} ${({ $kind }) => KEY_BADGE_TONES[$kind].border};
  border-radius: ${borderRadius.sm};
  padding: 0 ${spacing[1]};
  flex-shrink: 0;
`;
